import { Switch } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
`;

export const SwitchWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const TitleWrapper = styled.div`
  display: flex;
  gap: 8px;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
`;

export const StyledSwitch = styled(Switch)<{ $customColor?: string }>`
  ${({ $customColor }) =>
    $customColor &&
    `
    &.ant-switch-checked { background-color: ${$customColor}; }
    &.ant-switch-checked:hover:not(.ant-switch-disabled) { background: ${$customColor}; }
  `}
`;
